import React from "react";
import AppRoutes from "@routes/index.tsx";

const App: React.FC = () => {
  return <AppRoutes />;
};

export default App;
